import { render, staticRenderFns } from "./ConfirmPhoneDialog.vue?vue&type=template&id=52cdddf2&"
import script from "./ConfirmPhoneDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhoneDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports